import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloPisoCaucho from '../components/sections/PisoDeCaucho/TituloPisoCaucho';
import IntroPisoCaucho from '../components/sections/PisoDeCaucho/IntroPisoCaucho';
import FabricadoPisoCaucho from '../components/sections/PisoDeCaucho/FabricadoPisoCaucho';
import CaracteristicasPisoCaucho from '../components/sections/PisoDeCaucho/CaracteristicasPisoCaucho'; 
import CatalogoPisoCaucho from '../components/sections/PisoDeCaucho/CatalogoPisoCaucho';
import FormularioContactoCaucho from '../components/sections/PisoDeCaucho/FormularioContactoCaucho';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisoDeCauchoPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Piso de Caucho Reciclado | Decototal"
        description="Descubre pisos de caucho reciclado para espacios deportivos y áreas de alto tránsito. Consulta modelos, colores y solicita una cotización."
        keywords="piso de caucho reciclado, piso para gimnasio, piso deportivo, loseta de caucho"
        path="/piso-de-caucho-page"
        image="/assets/img/productos/piso-caucho-reciclado/piso-caucho-catalogo-azul-titulo.jpg"
      />
      <Header />

        <TituloPisoCaucho /> 
        <IntroPisoCaucho /> 
        <CaracteristicasPisoCaucho /> 
        <CatalogoPisoCaucho />
        <FabricadoPisoCaucho />  
        <FormularioContactoCaucho />
        
      <Footer />
    </div>
  );
};

export default PisoDeCauchoPage;